import { createRef, Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
import EventListener, { withOptions } from 'react-event-listener';
import { logCategoryActionLabel } from '../../actions/logging';

const TIMEOUT = 100;

export default function withGuideItemTracking(ComponentToDecorate) {
  class WithGuideItemTracking extends Component {
    static propTypes = {
      guideItem: PropTypes.object.isRequired,
      actions: PropTypes.object.isRequired,
    };

    constructor(props) {
      super(props);

      this.timeout = null;
      this.ref = createRef();

      this.state = {
        hasBeenReported: false,
        isDisplayed: true,
      };

      this.isRefInView = this.isRefInView.bind(this);
      this.closeGuideItem = this.closeGuideItem.bind(this);
      this.reportIfInView = debounce(this.reportIfInView.bind(this), TIMEOUT);
    }

    componentDidMount() {
      this.reportIfInView();
    }

    closeGuideItem() {
      this.setState({
        isDisplayed: false,
      });
    }

    isRefInView() {
      if (!this.ref.current) {
        return false;
      }

      const bounding = this.ref.current.getBoundingClientRect();

      return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    reportIfInView() {
      const { hasBeenReported } = this.state;
      if (!hasBeenReported && this.isRefInView()) {
        const { guideItem, actions } = this.props;
        const itemToken = get(guideItem, 'context.token');
        const reportData = get(guideItem, 'actions.view.reportData', '');
        actions.logCategoryActionLabel(reportData, { itemToken });
        this.setState({
          hasBeenReported: true,
        });
      } else if (hasBeenReported && !this.isRefInView()) {
        this.setState({
          hasBeenReported: false,
        });
      }
    }

    render() {
      return (
        this.state.isDisplayed && (
          <EventListener
            target="window"
            onScroll={withOptions(this.reportIfInView, {
              passive: false,
              capture: true,
            })}
          >
            <ComponentToDecorate
              trackingRef={this.ref}
              closeGuideItem={this.closeGuideItem}
              {...this.props}
            />
          </EventListener>
        )
      );
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      logCategoryActionLabel,
    };

    return {
      actions: bindActionCreators(actions, dispatch),
    };
  }

  return connect(null, mapDispatchToProps)(WithGuideItemTracking);
}
